import {LoggerLevel} from '@common-lib';

export const environment = {
    production: false,
    API_URL: 'https://imnordicconf-10057.conf.staging-api.rapidimages.net/webapi',
    SOCKET_IO_URL: 'https://imnordicconf-10057.conf.staging-api.rapidimages.net',
    BASE_PATH: '/',
    LOG_LEVEL: LoggerLevel.DEBUG,
    DEFAULT_LANGUAGE: 'en',
    DEFAULT_LOCALE: 'en-EN',
    plugin_gotenehus_on : false
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts